const STANDS = new Set(["boisson", "repas", "dessert", "artisan"]);

/**
 * Nom caisse + lignes ticket :
 * "Libellé || boisson:1 Boisson | repas:1 Repas | dessert:1 Dessert"
 */
export const parseArticleKit = (name = "") => {
    const raw = String(name || "");
    if (!raw.includes("||")) {
        return { displayName: raw, kitLines: null };
    }
    const [display, rest = ""] = raw.split("||").map((part) => part.trim());
    const kitLines = rest
        .split("|")
        .map((part) => part.trim())
        .filter(Boolean)
        .map((part) => {
            const colon = part.indexOf(":");
            if (colon > 0) {
                const maybeStand = part.slice(0, colon).trim().toLowerCase();
                if (STANDS.has(maybeStand)) {
                    return {
                        stand: maybeStand,
                        name: part.slice(colon + 1).trim() || part,
                    };
                }
            }
            return { stand: "repas", name: part };
        });

    return {
        displayName: display || raw,
        kitLines: kitLines.length > 0 ? kitLines : null,
    };
};

/** Ticket Artisan / Tracteur : on demande la quantité (nb de personnes) */
export const isKitArticle = (article, categoryStand) => {
    if (!article) return false;
    if (categoryStand === "artisan" || article.stand === "artisan") return true;
    return Boolean(parseArticleKit(article.name).kitLines?.length);
};

/** @deprecated use isKitArticle */
export const isMultiPrintArticle = isKitArticle;

export const expandArticleToStandLines = (article) => {
    const qty = Math.max(1, Number(article.amount || 1));
    const unitPrice = Number(article.price) || 0;
    const fallbackStand = article.stand || "repas";
    const { displayName, kitLines } = parseArticleKit(article.name);
    const lines = [];

    if (kitLines?.length) {
        for (let copy = 0; copy < qty; copy += 1) {
            kitLines.forEach((kitLine, lineIndex) => {
                lines.push({
                    name: kitLine.name,
                    price: lineIndex === 0 && copy === 0 ? unitPrice : 0,
                    stand: kitLine.stand || fallbackStand,
                });
            });
        }
        return lines;
    }

    for (let copy = 0; copy < qty; copy += 1) {
        lines.push({
            name: displayName,
            price: copy === 0 ? unitPrice : 0,
            stand: fallbackStand,
        });
    }
    return lines;
};
